import React, { useCallback, useRef } from 'react'
import classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import { useRenderedComponentContext } from 'front-end/src/components/RenderedComponentContext'

export const useRouteTransition = (location, className?: string) => {
  const loc = useRef(location)
  const { renderedComponentName } = useRenderedComponentContext()
  const classes = classNames('reactSpring__transition__wrapper', className)

  const RouteTransition = useCallback(
    ({ children }) => (
      <AnimatePresence>
        <motion.div
          key={renderedComponentName || loc.current.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, position: 'absolute' }}
          // not sure if we really want this because it looks better without it
          // original react-spring cfg for reference:
          // { mass: 4, tension: 50, friction: 18, velocity: 2, clamp: true }
          //transition={{ type: 'spring', mass: 4, stiffness: 50 }}
          className={classes}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    ),
    [renderedComponentName]
  )

  loc.current = location

  return { RouteTransition }
}
